window.Vue = require('vue');

import {initHelpers, initFileInput} from './helpers.js';
import axios from 'axios';


window.axios = axios;

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

Vue.component('ck-flash', require('./components/ckFlash.vue'));
Vue.component('ck-vuetable', require('./components/CkVuetable.vue'));
// Vue.component('ck-navbutton', require('./components/ckNavbutton.vue'));
Vue.component('ck-player-relatives', require('./components/Players/Relatives.vue'));
Vue.component('ck-player-notes', require('./components/Players/Notes.vue'));
Vue.component('ck-logout-link', require('./components/ckLogoutLink.vue'));
Vue.component('ck-add-person-thumbnail', require('./components/ckAddPersonThumbnail.vue'));
Vue.component('ck-add-contact', require('./components/ckAddContact.vue'))
Vue.component('ck-create-partner', require('./components/ckCreatePartner.vue'));
Vue.component('ck-filelink', require('./components/ckFileLink.vue'));
Vue.component('ck-add-folder', require('./components/ckAddFolder.vue'));
Vue.component('ck-upload-file', require('./components/ckUploadFile.vue'));
Vue.component('ck-add-accounting', require('./components/ckAddAccounting.vue'));
Vue.component('ck-saldo-chart', require('./components/charts/ckSaldoChart.vue'));
Vue.component('ck-dropzone', require('./components/ckDropzone.vue'));
Vue.component('ck-annotation', require('./components/ckAnnotation.vue'));
Vue.component('ck-saldo-widget', require('./components/ckSaldoWidget.vue'));

//Vue.component('contact-list-detail-row', require('./components/contactListDetailRow'))
//Vue.component('ck-add-event', require('./components/Calendar/ckAddEvent.vue'));
const app = new Vue({
    el: '#app'
});

// This is the event hub we'll use in every
// component to communicate between them.
const eventHub = new Vue();

// Distribute to components using global mixin
Vue.mixin({
    data: function () {
        return {
            eventHub: eventHub
        }
    }
})


initHelpers()




// WEBPACK FOOTER //
// ./resources/assets/js/app.js